import { ClientProxy } from '../../../../../base/proxy/clientProxy'
import { IRequesterInfo } from '../../../../../base/models'
import { IProductAISuggestRequest, IProductSuggestRequest } from '../models/ProductSuggestListModel'

export class AddProductAISuggestApi extends ClientProxy {
  constructor(requesterInfo: IRequesterInfo) {
    super({
      url: 'admin/productSuggest/addProductAISuggest',
      requesterInfo,
    })
  }

  public async addProductSuggest(request: IProductAISuggestRequest): Promise<any> {
    return await this.postAsync<any>(request)
  }
}
